'use client';

import { Tooltip, UnstyledButton } from '@mantine/core';
import { IconSettings } from '@tabler/icons-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import classes from './Sidebar.module.css';

interface SidebarLinkProps {
  icon: typeof IconSettings;
  label: string;
  href?: string;
  external?: boolean;
  onClick?: () => void;
  collapsed: boolean;
  color?: string;
}

export function SidebarLink({
  icon: Icon,
  label,
  href,
  external,
  onClick,
  collapsed,
  color,
}: SidebarLinkProps) {
  const pathname = usePathname();
  const active = href
    ? pathname === href || pathname.startsWith(href + '/')
    : false;

  const content = (
    <UnstyledButton
      onClick={onClick}
      className={classes.link}
      data-active={active || undefined}
      data-collapsed={collapsed || undefined}
      style={color ? { color } : undefined}
    >
      <Icon size={20} stroke={1.5} />
      <span className={classes.linkLabel}>{label}</span>
    </UnstyledButton>
  );

  const wrap = (inner: React.ReactNode) => {
    if (!href) return inner;
    if (external) {
      return (
        <a href={href} target="_blank" rel="noopener noreferrer" className={classes.linkWrapper}>
          {inner}
        </a>
      );
    }
    return (
      <Link href={href} className={classes.linkWrapper}>
        {inner}
      </Link>
    );
  };

  if (collapsed) {
    return (
      <Tooltip label={label} position="right" transitionProps={{ duration: 0 }}>
        {wrap(content)}
      </Tooltip>
    );
  }

  return wrap(content);
}
